'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProvideProps = (_temp = _class = function (_Element) {
  (0, _inherits3.default)(ProvideProps, _Element);

  function ProvideProps() {
    (0, _classCallCheck3.default)(this, ProvideProps);
    return (0, _possibleConstructorReturn3.default)(this, _Element.apply(this, arguments));
  }

  ProvideProps.prototype.getProps = function getProps() {
    throw new Error('You need to override get props');
  };

  ProvideProps.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;

    var newProps = this.getProps();

    if (typeof children === 'function') {
      return this.replaceChildren(children(newProps));
    }if (typeof render === 'function') {
      return this.replaceChildren(render(newProps));
    }

    throw new Error('You need to set property render or children as function');
  };

  return ProvideProps;
}(_Element3.default), _class.propTypes = {
  render: _propTypes2.default.func,
  children: _propTypes2.default.func
}, _temp);
exports.default = ProvideProps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/ProvideProps.js
 ** module id = 140
 ** module chunks = 0
 **/